module.exports = __webpack_public_path__ + "static/media/2.5.d19b10b6.png";